import { Navigate, useLocation } from 'react-router-dom';

export const RemoveTrailingSlash = ({ ...rest }): React.ReactElement => {
    const { pathname, search } = useLocation();
    // If the last character of the url is '/'
    if (pathname?.match('/.*/$')) {
        return (
            <Navigate
                replace
                {...rest}
                to={{
                    pathname: pathname.replace(/\/+$/, ''),
                    search: search,
                }}
            />
        );
    } else return <></>;
};
